import { render, staticRenderFns } from "./org-sidebar.vue?vue&type=template&id=6486058b&scoped=true&"
import script from "./org-sidebar.vue?vue&type=script&lang=js&"
export * from "./org-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./org-sidebar.vue?vue&type=style&index=0&id=6486058b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486058b",
  null
  
)

export default component.exports